import { useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'

export function useSelectState({ multi } = EMPTY_OBJECT) {
  const [value, setValue] = useState(null)

  function handleClear() {
    setValue(null)
  }

  function handleClickTagClearButton(item) {
    setValue(prevValue => {
      const nextValue = prevValue.filter(
        prevValueItem => prevValueItem.value !== item.value
      )

      return nextValue.length > 0 ? nextValue : null
    })
  }

  function handleSelectItem(nextValue) {
    if (multi) {
      setValue(prevValue => {
        if (
          prevValue?.find(
            prevValueItem => prevValueItem.value === nextValue.value
          )
        ) {
          return prevValue.filter(
            prevValueItem => prevValueItem.value !== nextValue.value
          )
        } else {
          return [...(prevValue || EMPTY_LIST), nextValue]
        }
      })
    } else {
      setValue(nextValue)
    }
  }

  function handleSelectAll(nextValue) {
    setValue(nextValue)
  }

  return {
    handleClear,
    handleClickTagClearButton,
    handleSelectAll,
    handleSelectItem,
    value,
  }
}
